import React, { useEffect, useState, useMemo } from 'react'
import ScreenSizeContext from './ScreenSizeContext'

const LayoutContextProvider: React.FC = ({
  children
}) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)

  useEffect(() => {
    const setScreenSize = () => {
      setScreenWidth(window.innerWidth)
      setScreenHeight(window.innerHeight)
    }

    window.addEventListener('resize', setScreenSize)

    return () => {
      window.removeEventListener('resize', setScreenSize)
    }
  }, [])

  const layoutContextValue = useMemo(() => ({
    width: screenWidth,
    height: screenHeight,
  }), [screenWidth])

  return (
    <ScreenSizeContext.Provider value={layoutContextValue}>
      {children}
    </ScreenSizeContext.Provider>
  )
}

export default LayoutContextProvider
